import { InjectionToken } from '@angular/core';

/**
 * Value to use for `<input autocomplete="" />` to force autocomplete being turned off.
 *
 * Especially browsers like Chrome have a tendency to ignore `autocomplete="off"` in some cases.
 * This value is used to force autocomplete being turned off.
 */
export const FMNTS_FORMS_FORCE_AUTOCOMPLETE_OFF = new InjectionToken<AutoFill>(
  '@fmnts/common/forms/force-autocomplete-off',
  {
    factory: () => 'new-password',
  },
);

export interface CommonFormOptions {
  /** Whether browser autocomplete should be enabled on the form. */
  autocomplete?: boolean;
  /** If true, form fields will try to enforce autocomplete being disabled. */
  forceAutocompleteOff?: boolean;
}

/**
 * DI token for for configuring common form options.
 */
export const FMNTS_FORMS_OPTIONS = new InjectionToken<CommonFormOptions>(
  '@fmnts/common/forms/form-options',
  {
    factory: () => ({}),
  },
);
